//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @prop { Object } content
 * mainImg: 图片url
 * mainTitle: 主标题
 * rightTopTitle: 右上角标题
 * leftBottomTitle: 左下角icon
*/
export default {
  name: 'circle-bubble',
  props: {
    content: {
      type: Object,
      default: null
    },
    isAbTest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleItemClick: function handleItemClick() {
      this.$emit('item-click', this.content);
    }
  }
};